import { TextWrapper } from "../../../constants/common/StyledGlobalConstants";
import { ItemContainer, ContactContainer, LabelContainer, ErrorContainer, CustomInput } from "../../../../src/components/myContract/ContactMe.styles";
import { StarSpan } from "./CamerasAndOtherAccessories";
import { handleVehicleValidations } from "../../../util/vehicleValidationUtil";
import { useSelector } from "react-redux";
import TryAgain from "./TryAgain";
import "../../../constants/common/StyleOnlyForScreenReader.css";
import { getPendoId } from "../../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import PropTypes from "prop-types";

const { TABLET } = DEVICE_BREAKPOINTS;

function NewVehicleorAsset({
  vin,
  setVin,
  newVehicle,
  setNewVehicle,
  showVin,
  checkAccessoriesSection,
  handleTryAgain,
  isServiceFailure,
  isBlockingError,
  validatedInvalidVin,
}) {
  const { windowSize } = useSelector((state) => state.ACCOUNT);

  const handleChange = (field, inputValue, setter) => {
    if ((inputValue.length <= 17 && field === "vin") || (inputValue.length <= 100 && field === "vehicleName")) {
      const validationResult =
        field === "vin" && validatedInvalidVin === inputValue
          ? { isValid: false, errorText: "VIN is invalid", value: inputValue }
          : handleVehicleValidations(field, inputValue);
      if (validationResult) {
        let { isValid, errorText, value } = validationResult;
        setter((prevState) => ({
          ...prevState,
          isValid,
          errorText,
          value,
        }));
      }
    }
  };

  return (
    <>
      <h3 className="sr-only" tabIndex="-1">
        New vehicle or powered asset
      </h3>
      <TextWrapper fontSize="1.5rem" fontWeight="700" lineHeight="2rem" marginTop="2rem !important" aria-hidden="true" tabIndex="-1">
        New vehicle or powered asset
      </TextWrapper>
      <TextWrapper fontSize="0.875rem" fontWeight="400" lineHeight="1.25rem" marginTop="1rem !important">
        Fill in the details of the vehicle or powered asset that the tracker will be transferred into.
      </TextWrapper>
      <>
        {isServiceFailure ? (
          <TryAgain padding="5.75rem 0rem" handleClick={handleTryAgain} />
        ) : (
          <>
            {showVin && (
              <>
                <ContactContainer desktop={windowSize.width > TABLET} width="23.188rem" marginTop="1.5rem">
                  <ItemContainer>
                    <LabelContainer>
                      <label htmlFor="cfst-vin">{"Vehicle identification number (VIN)"}</label>
                      <StarSpan>*</StarSpan>
                    </LabelContainer>
                    <div>
                      <CustomInput
                        id="cfst-vin"
                        required={!vin.isValid}
                        validGreen={!vin.isValid}
                        onChange={(e) => handleChange("vin", e.target.value, setVin)}
                        onFocus={checkAccessoriesSection}
                        value={vin.value}
                        placeholder="Enter VIN to find vehicle details"
                        maxlength="17"
                        disabled={isBlockingError}
                      />
                    </div>
                    {!vin.isValid && (
                      <ErrorContainer id="cfst-vin-error" role="alert" tabIndex="-1" aria-live="assertive">
                        {vin.errorText}
                      </ErrorContainer>
                    )}
                    {vin.isValid && vin.value > 0 && (
                      <span className="sr-only" tabIndex="-1" role="alert">
                        Please stop here. System will not accept more than 17 characters. You already entered 17 characters.
                      </span>
                    )}
                  </ItemContainer>
                </ContactContainer>
                <ContactContainer desktop={true} width="100%" marginTop="4px">
                  <TextWrapper fontWeight="400" fontSize="12px" color="#6F7171">
                    Need help finding your VIN?{" "}
                    <a
                      href="https://install.verizonconnect.com/hc/en-us/articles/360060393273-FAQ-Where-can-I-find-the-vehicle-identification-number-VIN"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Learn more about finding your VIN (opens in new tab)"
                      style={{ color: "#006FC1", textDecoration: "underline" }}
                      id={getPendoId("new-vin-learn-more")}
                    >
                      Learn more
                    </a>.
                  </TextWrapper>
                </ContactContainer>
              </>
            )}

            <ContactContainer desktop={true} marginTop="24px" width="100%">
              <ItemContainer>
                <LabelContainer>
                  <label>{"New vehicle or powered asset name"}</label>
                  <StarSpan>*</StarSpan>
                </LabelContainer>
                <div>
                  <CustomInput
                    onChange={(e) => handleChange("vehicleName", e.target.value, setNewVehicle)}
                    onBlur={(e) => handleChange("vehicleName", e.target.value, setNewVehicle)}
                    onFocus={checkAccessoriesSection}
                    id="cfst-name"
                    maxlength="100"
                    placeholder="Enter unique name"
                    value={newVehicle.value}
                    // validGreen={newVehicle.isValid}
                    required={!newVehicle.isValid}
                    width="100%"
                    disabled={isBlockingError}
                  />
                </div>
                {!newVehicle.isValid && (
                  <ErrorContainer role="alert" tabIndex="-1" aria-live="assertive">
                    {newVehicle.errorText}
                  </ErrorContainer>
                )}
              </ItemContainer>
            </ContactContainer>
            <ContactContainer desktop={true} width="100%" marginTop="4px">
              <TextWrapper fontWeight="400" fontSize="12px" color="#6F7171" lineHeight="18px">
                So you know it from the rest of your fleet. You can change this name later in Reveal.
              </TextWrapper>
            </ContactContainer>
          </>
        )}
      </>
    </>
  );
};

NewVehicleorAsset.propTypes = {
  vin: PropTypes.shape({
    isValid: PropTypes.bool.isRequired,
    errorText: PropTypes.string,
    value: PropTypes.string.isRequired,
  }).isRequired,
  setVin: PropTypes.func.isRequired,
  newVehicle: PropTypes.shape({
    isValid: PropTypes.bool.isRequired,
    errorText: PropTypes.string,
    value: PropTypes.string.isRequired,
  }).isRequired,
  setNewVehicle: PropTypes.func.isRequired,
  showVin: PropTypes.bool.isRequired,
  checkAccessoriesSection: PropTypes.func.isRequired,
  handleTryAgain: PropTypes.func.isRequired,
  isServiceFailure: PropTypes.bool.isRequired,
  isBlockingError: PropTypes.bool.isRequired,
  validatedInvalidVin: PropTypes.string,
};

export default NewVehicleorAsset;